<template>
  <transition name="ppdai-indicator">
    <div v-show="visible"
         class="ppdai-indicator"
         :class="customClass"
    >
      <div class="ppdai-indicator-wrapper"
           :class="{'has-text': !!text}"
           :style="wrapperStyle"
      >
        <svgIcon class-name="oval"
                 icon-class="oval"
        ></svgIcon>
        <span v-show="text"
              class="ppdai-indicator-text"
              :style="textStyle"
        >{{ text }}</span>
        <span v-show="tip"
              class="ppdai-indicator-tip"
              :style="tipStyle"
        >{{ tip }}</span>
      </div>
      <div class="ppdai-indicator-mask"
           :style="maskStyle"
           @touchmove.stop.prevent
      ></div>
    </div>
  </transition>
</template>

<script>
export default {
    'props': {
        'visible': { 'type': Boolean, 'default': false },
        'text': { 'type': String, 'default': '' },
        'tip': { 'type': String, 'default': '' },
        'customClass': { 'type': String, 'default': '' },
        'wrapperStyle': {
            'type': Object,
            'default': () => {}
        },
        'textStyle': {
            'type': Object,
            'default': () => {}
        },
        'tipStyle': {
            'type': Object,
            'default': () => {}
        },
        'maskStyle': {
            'type': Object,
            'default': () => {}
        }
    },
    data () {
        return {}
    },

    'computed': {}
}
</script>

<style lang="less">
@import '../../../assets/less/mixins.less';
.ppdai-indicator {
  transition: opacity 0.2s linear;
  .ppdai-indicator-wrapper {
    position: fixed;
    top: 50%;
    left: 50%;
    padding: 26px 30px;
    transform: translate(-50%, -50%);
    border-radius: 15px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    box-sizing: border-box;
    text-align: center;
    z-index: 1001;
    line-height: 1.2;
    &.has-text {
      padding: 24px 32px;
    }
  }
  .oval {
    font-size: 38px;
  }
  .ppdai-indicator-text {
    display: block;
    color: #fff;
    text-align: center;
    margin-top: 20px;
    font-size: 16px;
  }

  .ppdai-indicator-tip {
    display: block;
    color: #fff;
    text-align: center;
    font-size: 16px;
  }

  .ppdai-indicator-spin {
    display: inline-block;
    text-align: center;
  }

  .ppdai-indicator-mask {
    position: fixed;
    top: 0;
    left: 0;
    .setSize(100%, 100%);
    opacity: 0;
    background: transparent;
    z-index: 3000;
  }
}

.ppdai-indicator-enter,
.ppdai-indicator-leave-active {
  opacity: 0;
}
</style>
